import { FC, Fragment, useContext } from 'react';
import {
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  Separator,
  Stack,
  Text,
  useSlotRecipe,
} from '@chakra-ui/react';

import { EMPTY_ARR } from '~/core/shared/constants';
import {
  SummaryContentComponentElement,
  SummaryFormat,
} from '~/core/shared/types';
import { ApplicationContext } from '../Layout.component';
import { ContactCard } from './elements/ContactCard';
import {
  checkIncorporatedEntity,
  filterIncorporatedFields,
} from './logic/filterIncorporatedEntity';
import { parseContactContentElements } from './logic/parseContactContentElements';
import { ContentElement } from './ContentElement.component';
import { EditDetails } from './EditDetails';

type ApplicationQuickInfoProps = {
  contentElements: SummaryContentComponentElement[];
};

export const ApplicationQuickInfo: FC<ApplicationQuickInfoProps> = ({
  contentElements = EMPTY_ARR as SummaryContentComponentElement[],
}) => {
  const recipe = useSlotRecipe({ key: 'summaryHeaderContent' });
  const headerStyles = recipe();
  const { definition } = useContext(ApplicationContext);
  const isIncorporatedEntity = checkIncorporatedEntity(contentElements);

  const contacts = parseContactContentElements(contentElements);
  const quickInfoElements = contentElements.filter(
    (e) => e.format !== SummaryFormat.Contact,
  );

  return (
    <Box css={headerStyles.box}>
      <Flex alignItems="center" css={headerStyles.heading} direction="row">
        <Text fontWeight="bold" maxW="309px" w="30%">
          Primary contact
        </Text>
        <HStack justifyContent="space-between" w="100%">
          <Text fontWeight="bold">Quick info</Text>
          <EditDetails documentType={definition} title="Quick info" />
        </HStack>
      </Flex>
      <HStack alignItems="flex-start" css={headerStyles.content} gap={4}>
        <Stack gap={4} minW="300px">
          {contacts.map((contact, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={idx}>
              {idx > 0 && <Separator />}
              <ContactCard contact={contact} />
            </Fragment>
          ))}
        </Stack>
        <Grid gap={6} templateColumns="repeat(3, 1fr)">
          {filterIncorporatedFields(
            quickInfoElements,
            isIncorporatedEntity,
          ).map((element) => (
            <GridItem key={element.id}>
              <ContentElement element={element} />
            </GridItem>
          ))}
        </Grid>
      </HStack>
    </Box>
  );
};
